<div class="content-box">
  <section class="pedido" aria-labelledby="pedido-titulo">
    <app-breadcrumb [pagina]="titulos()[etapaAtual()]" [intermediarios]="trilha"></app-breadcrumb>

    <div class="pedido-topo">
      <h1 class="pedido-titulo" id="pedido-titulo">Serviço de Informação ao Cidadão (SIC)</h1>

      @if (etapaAtualId() !== 'confirmacao') {
        <div class="pedido-acoes">
          <button type="button" class="pedido-botao pedido-enviar" (click)="irParaLogin()">
            <i-lucide name="send" size="16" aria-hidden="true"></i-lucide>
            Abrir pedido e-SIC
          </button>
        </div>
      }
    </div>

    <div class="pedido-banner">
      <img
        class="pedido-banner-imagem"
        [ngSrc]="banner.caminho"
        [width]="banner.largura"
        [height]="banner.altura"
        priority
        alt=""
      />
    </div>

    <app-etapas-servico
      #trilhaEtapas
      [etapas]="titulos()"
      [etapaAtual]="etapaAtual()"
      [etapaLiberada]="etapaLiberada()"
      [mensagemBloqueio]="mensagemBloqueio()"
      (selecionar)="irParaEtapa($event)"
    ></app-etapas-servico>

    @switch (etapaAtualId()) {
      @case ('orientacoes') {
        <app-etapa-orientacoes-sic
          [focarLogin]="focarLogin()"
          (continuar)="continuarIdentificado()"
          (autenticado)="autenticar()"
          (acessarGov)="acessarGov()"
          (seguirAnonimo)="seguirAnonimo()"
          (saiu)="encerrarSessao()"
        ></app-etapa-orientacoes-sic>
      }
      @case ('identificacao') {
        <app-etapa-identificacao-sic
          [focarLogin]="focarLogin()"
          (autenticado)="autenticar()"
          (acessarGov)="acessarGov()"
          (seguirAnonimo)="seguirAnonimo()"
          (saiu)="encerrarSessao()"
        ></app-etapa-identificacao-sic>
      }
      @case ('dados') {
        <app-etapa-dados-pedido-sic></app-etapa-dados-pedido-sic>
      }
      @case ('anexos') {
        <app-etapa-anexos-sic></app-etapa-anexos-sic>
      }
      @case ('confirmacao') {
        <app-etapa-confirmacao-sic (novoPedido)="reiniciar()"></app-etapa-confirmacao-sic>
      }
    }

    @if (etapaAtualId() !== 'orientacoes' && etapaAtualId() !== 'confirmacao') {
      <div class="pedido-navegacao">
        <button type="button" class="pedido-botao pedido-voltar" (click)="voltar()">
          <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
          Voltar
        </button>

        <div class="pedido-navegacao-final">
          @if (store.preenchido()) {
            <button type="button" class="pedido-botao pedido-cancelar" (click)="cancelar()">
              Cancelar pedido
            </button>
          }

          @if (etapaAtualId() === ultimaEtapaAntesDoEnvio()) {
            <button
              type="button"
              class="pedido-botao pedido-avancar"
              [disabled]="store.enviando()"
              [attr.aria-busy]="store.enviando()"
              (click)="enviar()"
            >
              <i-lucide name="send" size="16" aria-hidden="true"></i-lucide>
              {{ store.enviando() ? 'Enviando…' : 'Enviar pedido' }}
            </button>
          } @else {
            <button type="button" class="pedido-botao pedido-avancar" (click)="avancar()">
              Próxima etapa
              <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
            </button>
          }
        </div>
      </div>
    }
  </section>
</div>
